export type ChartHoverSyncListener = (x: number | null, sourceChartId: string) => void;

export interface ChartHoverSync {
  setHoverX: (chartId: string, x: number | null) => void;
  subscribe: (subscriberId: string, listener: ChartHoverSyncListener) => () => void;
}

const hoverClearDelayMs = 50;

export function createChartHoverSync(): ChartHoverSync {
  const subscribers = new Map<string, ChartHoverSyncListener>();
  let activeSourceId: string | null = null;
  let clearTimeoutId: ReturnType<typeof setTimeout> | null = null;

  const notify = (x: number | null, sourceChartId: string) => {
    for (const listener of subscribers.values()) {
      listener(x, sourceChartId);
    }
  };

  const cancelPendingClear = () => {
    if (clearTimeoutId != null) {
      clearTimeout(clearTimeoutId);
      clearTimeoutId = null;
    }
  };

  return {
    setHoverX(chartId: string, x: number | null) {
      if (x != null) {
        cancelPendingClear();
        activeSourceId = chartId;
        notify(x, chartId);
        return;
      }

      if (chartId !== activeSourceId) {
        return;
      }

      cancelPendingClear();
      clearTimeoutId = setTimeout(() => {
        if (activeSourceId === chartId) {
          activeSourceId = null;
          notify(null, chartId);
        }
        clearTimeoutId = null;
      }, hoverClearDelayMs);
    },
    subscribe(subscriberId: string, listener: ChartHoverSyncListener) {
      subscribers.set(subscriberId, listener);
      return () => {
        subscribers.delete(subscriberId);
      };
    },
  };
}
